import Vue from 'vue';
import VueRouter from 'vue-router';
import FilterApp from '../FilterApp.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/find-a-therapist/',
    name: 'search',
    component: FilterApp
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;